import styled from '@emotion/styled';
import { AssignedLrwRoomDto } from 'api/planning';
import { Table } from 'semantic-ui-react';
import { useMemo, useState } from 'react';
import isPropValid from '@emotion/is-prop-valid';
import { LrwSessionRoomRow } from './LrwSessionRoomRow';

type Props = {
  lrwRooms: AssignedLrwRoomDto[];
};

export const LrwSessionRoomsTable = ({ lrwRooms }: Props) => {
  const [currentlyUpdatedRoom, setCurrentlyUpdatedRoom] = useState<number | undefined>(undefined);

  const seatLimitSumByRoomId = useMemo(() => {
    const map: Record<string, number> = {};
    for (const room of lrwRooms) {
      map[room.roomId] = (map[room.roomId] ?? 0) + (room.seatLimit ?? 0);
    }
    return map;
  }, [lrwRooms]);

  const rows = lrwRooms.map((room) => {
    return (
      <LrwSessionRoomRow
        room={room}
        seatLimitSum={seatLimitSumByRoomId[room.roomId] - room.seatLimit}
        key={room.id}
        currentlyUpdatedRoom={currentlyUpdatedRoom}
        setCurrentlyUpdatedRoom={setCurrentlyUpdatedRoom}
      />
    );
  });

  return (
    <Table celled striped>
      <S.TableHeader>
        <Table.Row>
          <Table.HeaderCell>Agent</Table.HeaderCell>
          <Table.HeaderCell>Building</Table.HeaderCell>
          <S.TableHeaderCell size="100px">Floor</S.TableHeaderCell>
          <Table.HeaderCell>Room</Table.HeaderCell>
          <S.TableHeaderCell size="100px">Registrations</S.TableHeaderCell>
          <S.TableHeaderCell size="100px">Total seats</S.TableHeaderCell>
          <S.TableHeaderCell size="200px">Max seat limit</S.TableHeaderCell>
          <S.TableHeaderCell size="0"></S.TableHeaderCell>
        </Table.Row>
      </S.TableHeader>
      <Table.Body>{rows}</Table.Body>
    </Table>
  );
};

const S = {
  TableHeader: styled(Table.Header)`
    .ui.table > thead& {
      box-shadow: 0 5px 5px #0001;
    }
  `,
  TableHeaderCell: styled(Table.HeaderCell, {
    shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'size',
  })<{ size: string }>`
    th& {
      width: ${(props) => props.size};
    }
  `,
};
